import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import { fetchDoctorDatasss, getCountry, getcountryname, getState, gethcountryname, UploadImageData, fetchSpecialData, fetchLan, fetchlanguage } from '../reduxactions/doctoractions/DoctorProfileActions';
import useEffectOnce from '../hooks/useEffectOnce';
import { Panel } from 'primereact/panel';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { Admin_API, DOCTOR_API, PATIENT_API, SUPRIVISOR_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { SelectButton } from 'primereact/selectbutton';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import eventBus from '../doctorapprover/eventBus';
export const DoctorProfile = () => {
  const uid = window.sessionStorage.getItem('uid');

  const [globalFilter, setGlobalFilter] = useState('');
  const stepperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const options = ['Personal Info', 'Hospital Info'];
  const [value, setValue] = useState(options[0]);
  const dispatch = useDispatch();
  const data = useSelector((state: RootState) => state.doctorprofile.data);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [idcard, setIdCard] = useState('');
  const [dob, setDateOfBirth] = useState('');
  const [gender, setGender] = useState('');
  const [phone, setPhone] = useState('');
  const [profile, setProfile] = useState('');
  const [mob, setMob] = useState('');
  const [skype, setSkype] = useState('');
  const [category, setCategory] = useState('');
  const [bankname, setBankName] = useState('');
  const [bankaccountno, setBankAccNo] = useState('');
  const [fax, setFax] = useState('');
  const [Speciality, setSpeciality] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState<any>();
  const [city, setCity] = useState('');
  const [street, setStreet] = useState('');
  const [dno, setDNO] = useState('');
  const [zip, setZip] = useState('');
  const [language, setLanguage] = useState<any[]>([]);
  const [hospital, setHosp] = useState('');
  const [reject, setreject] = useState('');
  const [ifscCode, setIFSCCode] = useState('');
  const [hospitalName, setHospitalname] = useState('');
  const [hospitalPrefix, setprefix] = useState('');
  const [hemail, setHEmail] = useState('');
  const [hphone, sethphone] = useState('');
  const [hcountry, sethcountry] = useState('');
  const [hstate, sethstate] = useState('');
  const [hcity, sethcity] = useState('');
  const [address, setAddress] = useState('');
  const [hpincode, sethpin] = useState('');

  const handleLanguageChange = (e: any) => {
    setLanguage(e.value);
  };
  const selectedIds = language.map((option: any) => option.LangID).join(',');
  const [photo, setPhoto] = useState('');

  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchDoctorDatasss(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch]);

  useEffect(() => {
    const profilephoto = data[0]?.photo;
    window.sessionStorage.setItem('photo', profilephoto);
    handlePhotoUpdate(profilephoto);
  }, [data]);

  const handlePhotoUpdate = (newPhoto: any) => {
    setPhoto(newPhoto);
    eventBus.emit('photoUpdated', newPhoto);
  };
  const spec = useSelector((state: RootState) => state.doctorprofile.speciality);
  useEffectOnce(() => {
    const fetchSpecData = async () => {
      try {
        await dispatch(fetchSpecialData() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchSpecData();
  }, [dispatch]);
  const lang = useSelector((state: RootState) => state.doctorprofile.lan);
  useEffectOnce(() => {
    const fetchLangData = async () => {
      try {
        await dispatch(fetchlanguage() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchLangData();
  }, [dispatch]);

  const [selectedFile, setselectedFile] = useState<File | null>(null);
  const fileUploadRef = useRef<FileUpload>(null)
  const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
    const files = event.files;
    if (files.length > 0) {
      const file = files[0];
      console.log("file:", file);
      setselectedFile(file);
      console.log("called image function:", file)
      try {
        await dispatch(UploadImageData(file, uid) as any);
        fetchDataAsync();
        if (fileUploadRef.current) {
          fileUploadRef.current.clear();
        }
        setselectedFile(null);
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }

  };
const uniqueLang = React.useMemo(() => {
  return Array.from(
    new Map(lang.map((l: any) => [l.LangID, l])).values()
  );
}, [lang]);


  //To get data
  const fetchDataAsync1 = async () => {
    try {
      const payload = { uid: uid };
      const apiname = DOCTOR_API.doctorprofile_API;
      const response = await LoginService.getData(apiname, payload);
      setFirstName(response[0].firstName);
      setLastname(response[0].lastName);
      setEmail(response[0].email);
      setIdCard(response[0].idcard);
      setDateOfBirth(response[0].dob);
      setGender(response[0].gender);
      setPhone(response[0].phone);
      setProfile(response[0].profile);
      setMob(response[0].mob);
      setSkype(response[0].skype);
      setCategory(response[0].plan);
      setBankName(response[0].bankname);
      setBankAccNo(response[0].bankaccountno);
      setFax(response[0].fax);
      setSpeciality(response[0].specialty);
      setCountry(response[0].country);
      setState(response[0].state);
      setCity(response[0].city);
      setStreet(response[0].street);
      setDNO(response[0].dno);
      setZip(response[0].zip);
      setHosp(response[0].hospitalid);
      setIFSCCode(response[0].ifsc);
      // console.log(response[0]?.language,"Options") ;
      // setLanguage(response[0].language);
      // setLanguage(response[0].language.map((id:any) => id));

      setreject(response[0].reject);

      setHospitalname(response[0].hospitalname)
      setprefix(response[0].hospitalprefix)
      setHEmail(response[0].hemail)
      sethphone(response[0].hphone)
      sethcountry(response[0].hcountry)
      sethstate(response[0].hstate)
      sethcity(response[0].hcity)
      sethpin(response[0].hpincode);
      setAddress(response[0].address);

      const selectedLangIDs = response[0].language.split(',');
      const mappedLanguages = selectedLangIDs.map((id: any) => id);
      setLanguage(mappedLanguages);

      const country = response[0]?.country;
      if (country) {
        fetchstate(country);
        getcountryvalue(country);
      }
      const hospitalid = response[0].hospitalid;
      if (hospitalid) {
        console.log("actionnnnnnn")
        getHospName(hospitalid)
      }
      const language = response[0].language;
      if (language) {
        getLanguage(language);
      }
      const hcountry = response[0].hcountry;
      if (hcountry) {
        gethcountryvalue(hcountry);
        fetchHstate(country);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  //add document
  const [Adddocument, setAdddocument] = useState(false);
  const close = () => {
    setAdddocument(false);
  }

  const [doctorcount, setDoctorCount] = useState(0);
  const [assistantcount, setAssistantCount] = useState(0);
  const [casesCount, setCasesCount] = useState(0);
  //get country state
  const countrydata = useSelector((state: RootState) => state.doctorprofile.country);
  const statedata = useSelector((state: RootState) => state.doctorprofile.state);
  const name = useSelector((state: RootState) => state.doctorprofile.name);
  const hcountryname = useSelector((state: RootState) => state.doctorprofile.hcountry);

  useEffectOnce(() => {
    const fetchcountry = async () => {
      try {
        await dispatch(getCountry() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchcountry();
  }, [dispatch]);

  const getcountryvalue = async (country: any) => {
    try {
      await dispatch(getcountryname(country) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const gethcountryvalue = async (hcountry: any) => {
    try {
      await dispatch(gethcountryname(hcountry) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const [languagesdata, setlanguagesData] = useState<[]>([]);

  const getLanguage = async (language: any) => {
    try {
      const payload = { q: 16, language: language };
      const apiname = SUPRIVISOR_API.sdashboard;
      const data = await LoginService.getData(apiname, payload);
      setlanguagesData(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const fetchstate = async (country: any) => {
    try {
      await dispatch(getState(country) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [hstatesData, setStateData] = useState<[]>([]);

  const fetchHstate = async (country: any) => {
    try {
      const payload = { q: 1, countryId: country };
      const apiname = SUPRIVISOR_API.getstate;
      const response = await LoginService.getData(apiname, payload);
      setStateData(response)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  console.log(hstatesData, "hstateData")
  const [hosplist, setHospList] = useState<[]>([]);

  const fetchHospList = async () => {
    try {
      const payload = { q: 1 };
      const apiname = Admin_API.Hospital_API;
      const response = await LoginService.getData(apiname, payload);
      const approvedHospitals = response.filter((item: any) => item.status === 'APPROVED');
      setHospList(approvedHospitals);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }



  useEffect(() => {
    fetchDataAsync1();
    fetchHospList();
  }, [dispatch]);
  const navigate = useNavigate();
  const viewPage1 = () => {
    const url = `/doctoruploads`;
    navigate(url);
  };


  const getAddressData = async () => {
    try {
      const payload = { address: address, uid: uid, q: 1 };
      const apiname = SUPRIVISOR_API.verifyadd;
      const data = await LoginService.getData(apiname, payload);

      if (data) {
        setAddress(data);
        //toast.current.show({ severity: 'success', summary: 'Verified Successfully', details: verify, life: 3000 });
      } else {
        setAddress('')
        console.warn('Invalid or empty response:', data);
      }
    } catch (error) {
      console.error('Error fetching address data:', error);
    }
  };
  const toast = useRef<Toast>(null);

  //update profile 
  const updateProfilePersonal = async () => {
    const setLang = language.join(',');
    try {
      const payload = { bankaccountno: bankaccountno, bankname: bankname, city: city, country: country, dno: dno, email: email, fax: fax, firstName: firstName, gender: gender, hospitalid: hospital, idcard: idcard, language: setLang, lastName: lastName, linkprofile: profile, mob: mob, phone: phone, plan: category, skype: skype, specialty: Speciality, state: state, street: street, zip: zip, dob: dob, ifsccode: ifscCode, uid: uid }
      const apiname = DOCTOR_API.doctorupdateprofile_API;
      const data = await LoginService.getData(apiname, payload);
      fetchDataAsync();
      if (toast.current) {
        toast.current.show({ severity: 'success', detail: data });
      }
      fetchDataAsync();
    } catch (error) {
      console.error('Error fetching address data:', error);
    }
  };
  const ApplyPersonalInfo = async () => {
    if (
      !bankaccountno || !bankname || !city || !country || !dno ||
      !fax || !state || !gender || !idcard || !profile || !mob || !phone || !skype || !Speciality || !street || !zip || !dob || !ifscCode
    ) {
      if (toast.current) {
        toast.current.show({ severity: 'error', detail: 'Please enter all fields.' });
      }
      return;
    }
    const setLang = language.join(',');
    try {
      const payload = { bankaccountno: bankaccountno, bankname: bankname, city: city, country: country, dno: dno, email: email, fax: fax, firstName: firstName, gender: gender, hospitalid: hospital, idcard: idcard, language: setLang, lastName: lastName, linkprofile: profile, mob: mob, phone: phone, plan: category, skype: skype, specialty: Speciality, state: state, street: street, zip: zip, dob: dob, ifsc: ifscCode, uid: uid }
      const apiname = DOCTOR_API.applydoctor_API;
      const data = await LoginService.getData(apiname, payload);
      fetchDataAsync();
      if (toast.current) {
        toast.current.show({ severity: 'success', detail: data });
      }
      fetchDataAsync();
    } catch (error) {
      console.error('Error fetching address data:', error);
    }
  };
  const genderoptions = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },

  ]

  const AcceptDoctor = async () => {
    try {
      const payload = { uid: uid };
      const apiname = SUPRIVISOR_API.accept_API;
      const data = await LoginService.getData(apiname, payload);
      fetchDataAsync();
      if (toast.current) {
        toast.current.show({ severity: 'success', detail: data });
      }
    } catch (error) {
      console.error('Error fetching address data:', error);
    }
  };

  //get hospital name
  const [getHospitalName, setHospitalName] = useState<[]>([]);

  const getHospName = async (hospitalid: any) => {
    try {
      const payload = { hospid: hospitalid, q: 17 };
      const apiname = SUPRIVISOR_API.sdashboard;
      const data = await LoginService.getData(apiname, payload);
      setHospitalName(data);

    } catch (error) {
      console.error('Error fetching address data:', error);
    }
  };

  //validations 
  const [phoneTouched, setPhoneTouched] = useState(false);
  const phoneError = {
    required: (phone || "").trim() === '',
    invalid: !/^\d{10}$/.test((phone || "").trim()) && (phone || "").trim() !== '',
  };
  const [phone1Touched, setPhone1Touched] = useState(false);
  const phoneError1 = {
    required: (mob || "").trim() === '',
    invalid: !/^\d{10}$/.test((mob || "").trim()) && (mob || "").trim() !== '',
  };
  const [accountTouched, setAccountTouched] = useState(false);

  const AccountNumberError = {
    required: (bankaccountno || "").trim() === '',
    invalid: !/^\d{8,16}$/.test((bankaccountno || "").trim()) && (bankaccountno || "").trim() !== '',
  };

  const zipError = {
    required: (zip || "").trim() === '',
    invalid: !/^\d{6}$/.test((zip || "").trim()) && (zip || "").trim() !== '',
  };
  const [zipTouched, setZipTouched] = useState(false);

  const streetError = {
    required: (street || "").trim() === '',
    invalid: !/^[A-Za-z0-9\s]+$/.test((street || "").trim()) && (street || "").trim() !== '',
  };
  const [streetTouched, setStreetTouched] = useState(false);

  const cityError = {
    required: (city || "").trim() === '',
    invalid: !/^[A-Za-z\s]+$/.test((city || "").trim()) && (city || "").trim() !== '',
  };
  const [cityTouched, setCityTouched] = useState(false);

  const errorStyle = {
    color: 'white',
    fontWeight: '400',
    backgroundColor: '#dc3545',
    height: '35px',
    alignItems: 'center',
    width: '380px',
    padding: '8px 10px',
    marginTop: '0px',
    marginLeft: '-10px',
  }
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/doctorprofile.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="content">
              <div className="grid">

                {data.map((response: any) =>
                  <div className="col-3">
                    <Panel
                      header=""
                      style={{
                        width: '280px',
                        borderTop: '3px solid #007bff',
                        textAlign: 'center',
                        borderRadius: '4px',
                        marginTop: '70px'
                      }}
                    >
                      <div>
                        <img
                          src={response.photo}
                          alt="User Avatar"
                          style={{
                            width: '110px',
                            height: '86px',
                            padding: '3px',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            border: '2px solid #adb5bd',
                          }}
                        />
                      </div>

                      <h3
                        className="widget-user-username"
                        style={{
                          color: 'black',
                          fontSize: '25px',
                          fontWeight: '300',
                          marginBottom: '20px',
                          marginTop: '20px'
                        }}
                      >
                        {response.firstName}
                      </h3>

                      <h2
                        className="widget-user-username"
                        style={{
                          color: '#6c757d',
                          fontSize: '20px',
                          fontWeight: '300',
                          marginBottom: '20px',
                        }}
                      >
                        Doctor
                      </h2>

                      <FileUpload
                        ref={fileUploadRef}
                        mode="basic"
                        id="fileToUpload"
                        name="fileToUpload"
                        customUpload
                        accept="image/*"
                        maxFileSize={1000000}
                        uploadHandler={UploadManagerImage}
                        auto
                      />
                      {selectedFile && <p style={{ marginTop: '10px' }}>{selectedFile.name}</p>}

                    </Panel>
                  </div>
                )}
                <div className='col-6' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <div className='col-12' >
                    <SelectButton value={value} onChange={(e) => setValue(e.value)} options={options} allowEmpty={false} />
                  </div>
                </div >
                <div className='col-3' >
                  <div style={{ marginTop: '40px', marginLeft: '-575px' }}>
                    <div className='col-2'></div>
                    <div className='col-2'></div>
                    <div className="col-16" style={{ textAlign: "right" }}>
                      <a
                        title="help"
                        onClick={(e) => openWindow(e, IUrl)}
                        style={{

                          color: "blue",
                          fontSize: 15, cursor: "pointer"
                        }}
                      >Help for this Page &nbsp;
                        <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                      </a>
                    </div>
                    {value == 'Personal Info' && (
                      <div>
                        <Card className="profile-header" style={{ width: '850px' }}>
                          <Panel header="Personal Info" toggleable>
                            <div style={{ width: '100%' }}>
                              <h1 style={{ textAlign: 'left', marginTop: '-10px', width: '100%', marginLeft: '20px' }}>
                                Doctor (*{data[0]?.status}*)
                              </h1>
                            </div>
                            <div className='grid'>
                              <div className="col-6">


                                <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="fname" className="block text-900 font-medium ">First Name</label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" type="text" placeholder="Enter Firstname" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="w-full mb-3" disabled />
                                </div>
                                <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="lname" className="block text-900 font-medium">Last Name</label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" type="text" placeholder="Enter LastName" value={lastName} onChange={(e) => setLastname(e.target.value)} className="w-full mb-3" disabled />
                                </div>
                                <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="email" className="block text-900 font-medium ">E-mail</label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" type="text" placeholder="Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mb-3" disabled />
                                </div>
                                <div className="col-5" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="email" className="block text-900 font-medium ">ID Card</label>

                                </div>
                                <div className="col-12">
                                  <InputText id="phone" type="number" placeholder="Enter IDCard" value={idcard} onChange={(e) => setIdCard(e.target.value)} className="w-full mb-3" />
                                </div>


                                <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="phone" className="block text-900 font-medium ">DateOfBirth</label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" type="date" placeholder="Enter DateOfBirth" value={dob} onChange={(e) => setDateOfBirth(e.target.value)} className="w-full mb-3" />
                                </div>

                                <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Gender</label>
                                </div>
                                <div className="col-12">
                                  <Dropdown id="country" value={gender} className="w-full mb-3" onChange={(e: DropdownChangeEvent) => setGender(e.value)} options={genderoptions} optionLabel="label" optionValue="value" placeholder="Select a Gender" style={{ textAlign: 'left' }} />
                                </div>
                                <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Phone Number </label>
                                </div>
                                <div className="col-12">
                                  <InputText type="tel" name="pincode" placeholder="Enter Phone Number" maxLength={10} className="w-full mb-3" value={phone} onChange={(e) => { setPhoneTouched(true); const value = e.target.value; if (/^\d{0,10}$/.test(value)) { setPhone(value); } }} />
                                  {phoneTouched && phoneError.invalid && (
                                    <div
                                      style={{
                                        color: 'white',
                                        fontWeight: '400',
                                        backgroundColor: '#dc3545',
                                        height: '35px',
                                        alignItems: 'center',
                                        width: '380px',
                                        padding: '8px 10px',
                                        marginTop: '0px',
                                        marginLeft: '-10px',
                                      }}
                                    >
                                      Invalid phone number: Must be exactly 10 digits
                                    </div>
                                  )}
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium "><i className="pi pi-linkedin ml-2" style={{ color: 'blue', fontSize: '30px' }}></i> LinkedIn Profile * </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" placeholder="Enter Profile" value={profile} onChange={(e) => setProfile(e.target.value)} className="w-full mb-3" />
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '220px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium "><i className="pi pi-whatsapp" style={{ color: 'green', fontSize: '30px' }}></i> Mobile (WhatsApp) * </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" type='tel' placeholder="Enter Mobile" value={mob} onChange={(e) => { const value = e.target.value; if (/^\d{0,10}$/.test(value)) setPhone1Touched(true); { setMob(value); } }} className="w-full mb-3" />
                                  {phone1Touched && phoneError1.invalid && (
                                    <div
                                      style={{
                                        color: 'white',
                                        fontWeight: '400',
                                        backgroundColor: '#dc3545',
                                        height: '35px',
                                        alignItems: 'center',
                                        width: '380px',
                                        padding: '8px 10px',
                                        marginTop: '0px',
                                        marginLeft: '-10px',
                                      }}
                                    >
                                      Invalid phone number: Must be exactly 10 digits
                                    </div>
                                  )}
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium "><i className="pi pi-pi-skype" style={{ color: 'blue', fontSize: '30px' }}></i> Skype ID * </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" placeholder="Enter Skype" value={skype} onChange={(e) => setSkype(e.target.value)} className="w-full mb-3" />
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Category </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" placeholder="Enter Category" value={category} onChange={(e) => setCategory(e.target.value)} className="w-full mb-3" disabled />
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Bank Name </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" placeholder="Enter BankName" value={bankname} onChange={(e) => setBankName(e.target.value)} className="w-full mb-3" />
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Account Number </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="accountnumber" type='number' placeholder="Enter AccountNo" value={bankaccountno} onChange={(e) => { const value = e.target.value; if (/^\d{0,16}$/.test(value)) setAccountTouched(true); { setBankAccNo(value); } }} className="w-full mb-3" />
                                  {accountTouched && AccountNumberError.required && (
                                    <div style={errorStyle}>Account number is required</div>
                                  )}
                                  {accountTouched && AccountNumberError.invalid && (
                                    <div style={errorStyle}>
                                      Invalid account number: Must be 8 to 16 digits
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Fax Number </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" placeholder="Enter Fax Number" value={fax} onChange={(e) => setFax(e.target.value)} className="w-full mb-3" />
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Speciality* </label>
                                </div>
                                <div className="col-12">
                                  <Dropdown id="country" value={Speciality} className="w-full mb-3" onChange={(e: DropdownChangeEvent) => setSpeciality(e.value)} options={spec} optionLabel="SpecilityName" optionValue="SpecilityID" placeholder="Select a Speciality" style={{ textAlign: 'left' }} />
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Country </label>
                                </div>
                                <div className="col-12">
                                  <Dropdown id="country" value={country} className="w-full mb-3" onChange={(e: DropdownChangeEvent) => { fetchstate(e.value); setCountry(e.value) }} options={countrydata} optionLabel="name" optionValue="countryids" placeholder="Select a Country" style={{ textAlign: 'left' }} />
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">State </label>
                                </div>
                                <div className="col-12">
                                  <Dropdown id="state" value={state} className="w-full mb-3" onChange={(e: DropdownChangeEvent) => setState(e.value)} options={statedata} optionLabel="name" optionValue="id" placeholder="Select a State" style={{ textAlign: 'left' }} />
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">City </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" placeholder="Enter City" value={city} onChange={(e) => { setCityTouched(true); setCity(e.target.value) }} className="w-full mb-3" />
                                  {cityTouched && cityError.required && (
                                    <div style={errorStyle}>City is required</div>
                                  )}
                                  {cityTouched && cityError.invalid && (
                                    <div style={errorStyle}>Invalid city: Only letters allowed</div>
                                  )}
                                </div>

                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Street </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" placeholder="Enter Street" value={street} onChange={(e) => { setStreetTouched(true); setStreet(e.target.value) }} className="w-full mb-3" />
                                  {streetTouched && streetError.required && (
                                    <div style={errorStyle}>Street is required</div>
                                  )}
                                  {streetTouched && streetError.invalid && (
                                    <div style={errorStyle}>Invalid street: Only letters and numbers allowed</div>
                                  )}
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Door No </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" placeholder="Enter Door Number" value={dno} onChange={(e) => setDNO(e.target.value)} className="w-full mb-3" />
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px', marginTop: '15px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Zip </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="phone" placeholder="Enter Zip" value={zip} onChange={(e) => setZip(e.target.value)} className="w-full mb-3" />
                                  {zipError.required && (
                                    <div style={errorStyle}>ZIP code is required</div>
                                  )}
                                  {zipError.invalid && (
                                    <div style={errorStyle}>Invalid ZIP code: Must be exactly 6 digits</div>
                                  )}
                                </div>
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px', marginTop: '15px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Hospital Name </label>
                                </div>
                                <div className="col-12">
                                  {data[0]?.login_status === 'SUPERVISOR' && (
                                    <Dropdown id="country" value={hospital} className="w-full mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setHosp(e.value)} options={getHospitalName} optionLabel="hospitalname" optionValue="hospid" placeholder="Select Hospital" style={{ width: '400px' }} disabled />
                                  )}
                                  {data[0]?.login_status !== 'SUPERVISOR' && (
                                    <Dropdown id="country" value={hospital} className="w-full mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setHosp(e.value)} options={hosplist} optionLabel="hospitalname" optionValue="hospitalID" placeholder="Select Hospital" style={{ width: '400px' }} />
                                  )}
                                </div>

                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="cardno" className="block text-900 font-medium ">Languages </label>
                                </div>
                                <div className="col-12">
                                  <MultiSelect
                                    value={language}
                                    options={lang}
                                    onChange={handleLanguageChange}
                                    display="chip"
                                    optionLabel="Lang"
                                    optionValue="LangID"
                                    className="w-full mb-3"
                                    filter
                                    filterBy="label"
                                    placeholder="Select a Language"
                                    itemTemplate={(option) => (
                                      <div className="flex align-items-center subacclist-item">
                                        <div>{`${option.Lang}`}</div>
                                      </div>
                                    )}
                                  />
                                </div>
                                {data[0]?.status !== 'APPROVED' && (
                                  <>
                                    <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                      <label htmlFor="cardno" className="block text-900 font-medium ">Reject Reason </label>
                                    </div>
                                    <div className="col-12">
                                      <InputText id="phone" placeholder="Enter Reject Reason" value={reject} onChange={(e) => setreject(e.target.value)} className="w-full mb-3" disabled />
                                    </div>
                                  </>

                                )}
                                <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                  <label htmlFor="ifsccode" className="block text-900 font-medium ">IFSC Code </label>
                                </div>
                                <div className="col-12">
                                  <InputText id="ifsccode" type='text' placeholder="Enter IFSC Code" value={ifscCode} onChange={(e) => { const value = e.target.value; if (/^[A-Za-z0-9]{0,16}$/.test(value)) { setIFSCCode(value); } }} className="w-full mb-3" />
                                </div>

                              </div>
                              <div className="col-12 card-footer">
                                <Button label="Update" className="p-button-primary" onClick={updateProfilePersonal} />
                                <Button label="Uploads" onClick={viewPage1} style={{ marginLeft: '35px' }} />
                                {data[0]?.status === 'WAITING FOR ACCEPTANCE' && (
                                  <Button label="Accept" severity='info' style={{ marginLeft: '35px' }} onClick={AcceptDoctor} />
                                )}
                                {data[0]?.status === 'REGISTERED' && (
                                  <Button label="Apply" severity='info' style={{ marginLeft: '35px' }} onClick={ApplyPersonalInfo} />
                                )}

                              </div>

                            </div>
                          </Panel>
                        </Card>
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', marginTop: '-3px', marginLeft: '-575px' }}>

                    {value == 'Hospital Info' && (
                      <div>
                        {(data[0]?.status !== 'REGISTERED' || data[0]?.loginstatus === 'SUPERVISOR') && (
                          <Card className="profile-header" style={{ width: '850px' }}>
                            <div className="grid">
                              <div className="col-12">


                                <div className="flex align-items-center mb-3">
                                  <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>HospitalName:</label>
                                  <InputText id="nameoforg" type="text" placeholder="Enter Name" value={hospitalName} onChange={(e) => setHospitalname(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                                </div>
                                <div className="flex align-items-center mb-3">
                                  <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Hospital Prefix:</label>
                                  <InputText id="nameoforg" type="text" placeholder="Enter Name" value={hospitalPrefix} onChange={(e) => setprefix(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                                </div>

                                <div className="flex align-items-center mb-3">
                                  <label htmlFor="email" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>E-Mail:</label>
                                  <InputText id="email" type="text" disabled placeholder="Enter E-mail" value={hemail} onChange={(e) => setEmail(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                </div>

                                <div className="flex align-items-center mb-3">
                                  <label htmlFor="phone" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Phone Number:</label>
                                  <InputText id="phone" type="number" placeholder="Enter Phone Number" value={hphone} onChange={(e) => sethphone(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} disabled />

                                </div>

                                <div className="flex align-items-center mb-3">
                                  <label htmlFor="address" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Country:</label>

                                  <Dropdown id="country" value={hcountry} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => { fetchstate(e.value); sethcountry(e.value) }} options={hcountryname} optionLabel="name" optionValue="id" placeholder="Select a Country" style={{ flex: 1, marginLeft: '10px', textAlign: 'left' }} disabled />
                                </div>

                                <div className="flex align-items-center mb-3">
                                  <label htmlFor="zip" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>State:</label>
                                  <Dropdown id="hstate" value={hstate} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => sethstate(e.value)} options={hstatesData} optionLabel="name" optionValue="name" placeholder="Select a State" style={{ flex: 1, marginLeft: '10px', textAlign: 'left' }} disabled />
                                </div>

                                <div className="flex align-items-center mb-3">
                                  <label htmlFor="country" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>City:</label>
                                  <InputText id="phone" type="text" placeholder="Enter City" value={hcity} onChange={(e) => sethcity(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} disabled />
                                </div>

                                <div className="flex align-items-center mb-3">
                                  <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Address:</label>
                                  <InputText id="phone" type="text" placeholder="Enter Address" value={address} onChange={(e) => setAddress(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} disabled />
                                </div>
                                <div className="flex align-items-center mb-3">
                                  <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Pincode:</label>
                                  <InputText id="phone" type="text" placeholder="Enter pincode" value={hpincode} onChange={(e) => sethpin(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} disabled />
                                </div>
                              </div>

                            </div>
                          </Card>
                        )}
                      </div>
                    )}
                  </div>

                </div>
              </div>

            </section>
          </div>
        </div>
        <Toast ref={toast} ></Toast>

      </div>
    </div>

  )
}
